module.exports = __webpack_public_path__ + "static/img/rank_32.4cb13f0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/rank_32.png
// module id = rD5e
// module chunks = 0